import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import Modal from '../modal/Modal';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { accountDuck } from '../../ducks/account';
import { cartDuck } from '../../ducks/cart';
import { locationDuck } from "../../ducks/location";
import { fetchLocationByStore } from "../../ducks/location/operations";
import { StateBootstrapButton as StateButton } from '../forms/elements';

var SavedCartModal = function SavedCartModal(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLocationUpdated = _useState6[0],
      setIsLocationUpdated = _useState6[1];

  useEffect(function () {
    var _props$account;

    if (!props.loyalty.showPersonalizationModal && ((_props$account = props.account) === null || _props$account === void 0 ? void 0 : _props$account.hasSavedCart)) {
      setIsOpen(true);
    }
  }, [props.account.hasSavedCart, props.loyalty.showPersonalizationModal]);
  useEffect(function () {
    var _props$account2;

    if (isLocationUpdated && ((_props$account2 = props.account) === null || _props$account2 === void 0 ? void 0 : _props$account2.hasSavedCart)) {
      window.location.href = "/cart";
      props.setHasSavedCart(false);
    }
  }, [props.location]);

  var handleHide = function handleHide() {
    setIsOpen(false);
    props.setHasSavedCart(false);
    props.dumpCart();
  };

  var handleResumeOrder = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _props$account3;

      var savedCartLocation, storeInfo, newStoreInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              savedCartLocation = (_props$account3 = props.account) === null || _props$account3 === void 0 ? void 0 : _props$account3.savedCartLocation;
              _context.next = 4;
              return fetchLocationByStore(savedCartLocation);

            case 4:
              storeInfo = _context.sent;

              if (storeInfo) {
                // parsing the information to get the same object structure used in other components
                newStoreInfo = _objectSpread(_objectSpread({}, storeInfo), {}, {
                  aboutus_description: storeInfo.AboutUsDescription,
                  address1: storeInfo.Address1,
                  address2: storeInfo.Address2,
                  alternate_name: storeInfo.AlternateName,
                  avgwaittime: storeInfo.AvgWaitTime,
                  beer_wine: storeInfo.BeerWine,
                  careers: storeInfo.Careers,
                  catering: storeInfo.Catering,
                  catering_delivery: storeInfo.CateringDelivery,
                  catering_deliveryavailable: storeInfo.CateringDeliveryAvailable,
                  catering_deliverylaunchdate: storeInfo.CateringDeliveryLaunchDate,
                  catering_menu: storeInfo.CateringMenu,
                  clientkey: savedCartLocation,
                  city: storeInfo.City,
                  country: storeInfo.Country,
                  curbside: storeInfo.Curbside,
                  detailLink: storeInfo.DetailLink,
                  dinein: storeInfo.DineIn,
                  dispatchindividual: storeInfo.DispatchIndividual,
                  english_breakfast: storeInfo.EnglishBreakfast,
                  english_lunchdinner: storeInfo.EnglishLunchDinner,
                  featuredmenu: storeInfo.FeaturedMenu,
                  front_porch_dining: storeInfo.FrontPorchDining,
                  frontporchdining: storeInfo.FrontPorchDining,
                  ghostkitchen: storeInfo.GhostKitchen,
                  cnbKitchen: storeInfo.CnbKitchen,
                  cnbUberEatsUrl: storeInfo.CnbUberEatsUrl,
                  cnbDoorDashUrl: storeInfo.CnbDoorDashUrl,
                  latitude: storeInfo.Latitude,
                  longitude: storeInfo.Longitude,
                  name: storeInfo.Name,
                  nowopen: storeInfo.NowOpen,
                  olo_catering_unique_name: storeInfo.OloCateringUniqueName,
                  olo_store: storeInfo.OloStore,
                  olo_unique_name: storeInfo.OloUniqueName,
                  onlineordering: storeInfo.OnlineOrdering,
                  openingsoon: storeInfo.OpeningSoon,
                  park: storeInfo.Park,
                  pay_in_app: storeInfo.PayInApp,
                  phone: storeInfo.Phone,
                  pickup: storeInfo.PickUp,
                  spanish_breakfast: storeInfo.SpanishBreakfast,
                  spanish_lunchdinner: storeInfo.SpanishLunchDinner,
                  specialhours: storeInfo.SpecialHours,
                  specialnotes: storeInfo.SpecialNotes,
                  state: storeInfo.State,
                  storeaddress: {
                    value: storeInfo.Address1
                  },
                  storename: {
                    value: storeInfo.AlternateName
                  },
                  storephone: {
                    value: storeInfo.Phone
                  },
                  storeuid: storeInfo.StoreId,
                  temporarilyclosed: storeInfo.TemporarilyClosed,
                  vendorid: storeInfo.VendorId,
                  vendoridcatering: storeInfo.VendorIdCatering,
                  waitlist_flag: storeInfo.Waitlist,
                  webaheadstatus: storeInfo.WebAheadStatus,
                  _distance: "",
                  _distanceuom: "",
                  postalcode: storeInfo.Zip
                });
                props.setLocation(newStoreInfo, "true");
                setIsLocationUpdated(true);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleResumeOrder() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleStartNewOrder = function handleStartNewOrder() {
    props.dumpCart();
    setIsOpen(false);
    props.setHasSavedCart(false);
  };

  return /*#__PURE__*/React.createElement(Modal, {
    className: 'loyalty-modal loyalty-modal--saved-cart',
    show: isOpen,
    hide: handleHide,
    hideCloseButton: true,
    backdrop: true,
    noHeader: true
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-saved-cart-modal'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-saved-cart-modal__body-container'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-saved-cart-modal__body-container__header'
  }, model === null || model === void 0 ? void 0 : model.fields["Headline"].value), /*#__PURE__*/React.createElement("span", {
    className: 'cb-saved-cart-modal__body-container__copy'
  }, model === null || model === void 0 ? void 0 : model.fields["Main Text"].value), /*#__PURE__*/React.createElement(StateButton, {
    loading: isLoading,
    className: "cb-button-primary cb-saved-cart-modal__body-container__button",
    onClick: handleResumeOrder
  }, model === null || model === void 0 ? void 0 : model.fields["Resume Button Text"].value), /*#__PURE__*/React.createElement(Button, {
    disabled: isLoading,
    className: "cb-button-secondary cb-saved-cart-modal__body-container__button",
    onClick: handleStartNewOrder
  }, model === null || model === void 0 ? void 0 : model.fields["Start Button Text"].value))));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    account: state.account,
    loyalty: state.loyalty,
    location: state.location,
    cart: state.cart
  };
};

var accountOperations = accountDuck.operations;
var cartOperations = cartDuck.operations;
var locationOperations = locationDuck.operations;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setHasSavedCart: function setHasSavedCart(show) {
      return dispatch(accountOperations.setHasSavedCart(show));
    },
    dumpCart: function dumpCart() {
      return dispatch(cartOperations.dumpCart());
    },
    setLocation: function setLocation(location, retaincart) {
      return dispatch(locationOperations.setLocation(location, retaincart));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedCartModal);